import React from 'react';
import Locales from 'locales';
import errorIcon from 'assets/img/error.png';
import Page from 'components/shared/Page';

const Error404 = () => {
  return (
    <Page removeContentStyles>
      <div className="flex justify-center gap-2 w-full items-center h-full lg:h-[80vh]">
        <div>
          <img className="w-[36px]" src={errorIcon} alt="404 error" />
        </div>

        <div className="flex flex-col gap-2 w-[90%] lg:w-[315px]">
          <p className="text-xl">{Locales.base.error_404.title}</p>
          <p>{Locales.base.error_404.subtitle}</p>
        </div>
      </div>
    </Page>
  );
};

export default Error404;
